export interface IComposerTransitionStep {
  isExternalStep?: boolean | null;
  createPdf?: boolean | null;
  isLastStep?: boolean | null;
}

export interface IShouldOpenTransitionComposerArgs {
  isForward: boolean;
  hasId: boolean;
  targetStep: IComposerTransitionStep | null | undefined;
  /**
   * When true, a last step does not open the composer. Change routes its last
   * step through a separate booking pass instead; the other modules leave this
   * false so their external last step opens the composer.
   */
  excludeLastStep?: boolean;
}

/**
 * @registry Decides whether advancing a workflow record should open the notification
 * composer: a forward move to a persisted record whose target step emails the client
 * (external step or PDF step). Shared by the four workflow forms.
 */
export const shouldOpenTransitionComposer = ({
  isForward,
  hasId,
  targetStep,
  excludeLastStep = false,
}: IShouldOpenTransitionComposerArgs): boolean => {
  if (!isForward || !hasId || !targetStep) return false;
  if (excludeLastStep && targetStep.isLastStep) return false;
  return !!(targetStep.isExternalStep || targetStep.createPdf);
};
